define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");

    var RESET_INTERVAL = 1000; // 1 sec.

    var SearchController = Marionette.Controller.extend({

        initialize: function (options) {

            options = options || {};

            this.searchInfo = {
                count:0,
                input:"",
                lastUpdate: 0
            };
            this.collection = options.collection || new Backbone.Collection();
        },

        //---------------------------------------------------------

        reset:function(){

            this.searchInfo.input = "";
            this.searchInfo.lastUpdate = 0;
        },

        //---------------------------------------------------------

        search:function(input, callback){

            var selectedItem = null;

            if(_.isString(input) && !_.isEmpty(input)){

                if ( /[a-zA-Z0-9]/.test(input)){

                    this.updateInput(input.toLowerCase());

                    selectedItem = this._search();

                    if(_.isObject(selectedItem)){
                        callback(selectedItem.get("key"));
                    }
                }
            }
        },

        //-----------------------------------------------------------

        updateInput:function(input){

            var now = new Date().getTime();

            if((now-this.searchInfo.lastUpdate)<RESET_INTERVAL){
                if(this.searchInfo.input === input){
                    this.searchInfo.count += 1;
                }else{
                    this.searchInfo.count = 1;
                    this.searchInfo.input += input;
                }
            }else{
                if(this.searchInfo.input === input){
                    this.searchInfo.count += 1;
                }else{
                    this.searchInfo.count = 1;
                    this.searchInfo.input = input;
                }
            }
            this.searchInfo.lastUpdate = now;
        },

        //------------------------------------------------------------

        _search:function(){

            var selectedItems = _.where(this.collection.models,_.bind(function(item) {
                var searchKey = String(item.has("searchKey") ? item.get("searchKey") : item.get("value")).trim().toLowerCase();

                if(!_.isString(searchKey)){
                    return false;
                }
                if(_.isEmpty(searchKey)) {
                    return false;
                }
                return searchKey.trim().toLowerCase().indexOf(this.searchInfo.input) === 0;
            },this));

            if(!_.isEmpty(selectedItems)){
                var index = (this.searchInfo.count -1) % selectedItems.length;
                return selectedItems[index];
            }
            return null;
        }
    });

    return SearchController;
});